import { Delivery } from 'app/models/Delivery';
import { PartOrder } from 'app/models/PartOrder';
import { Tour } from 'app/models/Tour';

export const canSendDeliveryConfirmationReminder = (
  delivery: Pick<Delivery, 'notification' | 'confirmed'>,
  partOrder: Pick<PartOrder, 'isKewlox'>,
): boolean =>
  partOrder.isKewlox && delivery.notification && !delivery.confirmed;

export const getPreviousConfirmationReminderLabel = (
  reminderCount: number,
): string =>
  reminderCount === 1
    ? '1 relance précédente'
    : `${reminderCount} relances précédentes`;

export const getDeliveryConfirmationReminderMessage = (
  reminderCount: number,
): string => {
  const baseMessage =
    'Un rappel de confirmation sera envoyé au client pour cette livraison.';

  if (reminderCount === 0) return baseMessage;

  return `${baseMessage} Cette livraison a déjà reçu ${getPreviousConfirmationReminderLabel(
    reminderCount,
  )}.`;
};

export const isEligibleTourConfirmationReminderDelivery = (
  delivery: Pick<
    Delivery,
    'notification' | 'confirmed' | 'partOrder' | 'waypoint'
  >,
): boolean =>
  delivery.partOrder !== undefined &&
  delivery.partOrder !== null &&
  delivery.waypoint === undefined &&
  delivery.notification &&
  !delivery.confirmed;

export const getTourConfirmationReminderCount = (
  tour: Pick<Tour, 'isKewlox'>,
  deliveries: Pick<
    Delivery,
    'notification' | 'confirmed' | 'partOrder' | 'waypoint'
  >[] = [],
): number => {
  if (!tour.isKewlox) return 0;

  return deliveries.filter(isEligibleTourConfirmationReminderDelivery).length;
};
